module.exports = __webpack_public_path__ + "img/av_lionfish.a6538492.png";